routing.$inject = ['$stateProvider'];

export default function routing($stateProvider) {

    $stateProvider
        .state('tag', {
            url: '/tag',
            abstract: true
        })

        .state('tag.index', {
            url: '',
            controller: 'TagsCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/tag/index.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:TAG:INDEX'
            }
        })

        .state('tag.create', {
            url: '/create',
            controller: 'TagCreateCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/tag/create.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CREATE',
                parent: 'tag.index'
            }
        })

        .state('tag.show', {
            url: '/{id}',
            controller: 'TagShowCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/tag/show.html'),
            params: {
                exportId: null,
                isFileExport: false,
            },
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:TAG:SHOW',
                parent: 'tag.index'
            }
        })

        .state('tag.export', {
            url: '/{id}/export',
            controller: 'TagExportCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/tag/export.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:TAG:EXPORT',
                parent: 'tag.show'
            }
        })
}
